import React, { useState, useEffect } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import TableChartIcon from "@mui/icons-material/TableChart";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllProjects } from "../../../store/slices/projectsSlice";
import { fetchWorkEntriesProjectTracking } from "../../../store/slices/workentriesSlice";
import { fetchEmployees } from "../../../store/slices/employeeSlice";
import { setmytrainingOMProjectAssignedState, setmytrainingOMProjectRequestState } from "../../../store/slices/OperationSlices/operationStateSlice";
import { useLoggedUser } from "../../../utils/useLoggedUser";

const TimeEntriesGraph = ({ ongoingProjectsManager, filteredOngoingEntries }) => {

  const loggedUser = useLoggedUser();
    const ongoingWorkentries = useSelector((state) => state.operationFeature.ongoingWorkentries);
    const ongoingProjectsRedux = useSelector((state) => state.operationFeature.ongoingProjectsRedux);
    // const ongoingHardwareParts = useSelector((state) => state.operationFeature.ongoingHardwareParts);

  const [filteredReports, setFilteredReports] = useState([]);
  const [probabilityTab, setProbabilityTab] = useState("graph");
  const [expandedProjectId, setExpandedProjectId] = useState(null);

  const dispatch = useDispatch()
  const mytrainingOMMyManagement = useSelector(
    (state) => state.operationState.mytrainingOMMyManagement
  );

  useEffect(() => {
    dispatch(fetchAllProjects())
    dispatch(fetchEmployees());
    dispatch(fetchWorkEntriesProjectTracking());
    dispatch(setmytrainingOMProjectRequestState());
    dispatch(setmytrainingOMProjectAssignedState())
  }, [dispatch]);

  const [ongoingEntries, setongoingEntries] = useState([]);

  useEffect(() => {
    if (ongoingWorkentries?.length && ongoingProjectsRedux?.length) {
      const ongoingProjectIds = ongoingProjectsRedux.map(project => project?._id);
      const filtered = ongoingWorkentries.filter((entry) => {
        const matchesProject = ongoingProjectIds.includes(entry.projectid);
        return matchesProject;
      });
      if (mytrainingOMMyManagement === "Assignment") {
        const managerEntries = filtered.filter((entry) => entry.taskownerid === loggedUser?._id)
        setongoingEntries(managerEntries);
      } else if (loggedUser?.EmpAuthLevel === "L4" && loggedUser?.customRoles?.includes("operations")) {
        const OperationEntries = filtered.filter((entry) => entry.taskownerid === loggedUser?._id)
        setongoingEntries(OperationEntries);
      } else {
        setongoingEntries(filtered);
      }
    } else {
      setongoingEntries([]);
    }
  }, [ongoingWorkentries, ongoingProjectsRedux, mytrainingOMMyManagement, loggedUser]);


  useEffect(() => {
    const ProjectsWithEntries = ongoingProjectsRedux.map((proj) => {
      const Entries = ongoingEntries.filter(
        (entry) => entry.projectid === proj?._id
      );
      return {
        ...proj,
        WorkEntries: Entries,
      };
    });

    setFilteredReports(ProjectsWithEntries);
  }, [ongoingProjectsRedux, ongoingEntries])


  const [projectHoursSummary, setProjectHoursSummary] = useState([]);

  const datadonut = projectHoursSummary.map((project) => ({
    name: project.projectName,
    value: project.totalHours,
  }));

  const toggleExpand = (id) => {
    setExpandedProjectId((prev) => (prev === id ? null : id));
  };

  useEffect(() => {
    const summary = filteredReports.map((report) => {
      const Entries = ongoingEntries.filter(
        (entry) => entry.projectid === report?._id
      );
      const totalHoursAssigned = Entries.reduce(
        (sum, entry) => sum + (entry.hoursassigned || 0),
        0
      );

      return {
        projectId: report._id,
        projectName: report.ProjectName,
        totalHours: totalHoursAssigned,
      };
    });

    setProjectHoursSummary(summary);
  }, [ongoingEntries, filteredReports]);

  const getColorForIndex = (index) => {
    const goldenRatio = 0.61803398875;
    const hue = (index * goldenRatio * 360) % 360;
    return `hsl(${hue}, 65%, 55%)`;
  };

  const TimeEntriesTg = (classlist) => {
    return (
      <div className={classlist}>
        <div className="max-h-[20rem] overflow-y-auto">
          {filteredReports?.map((report, index) => {
            const totalHoursAssigned = report?.WorkEntries.reduce(
              (sum, entry) => sum + (entry.hoursassigned || 0),
              0
            );
            const isExpanded = expandedProjectId === report._id;
            const projectColor = getColorForIndex(index);

            return (
              <div key={report._id} className="mb-1 border rounded">
                <div
                  className="flex justify-between p-1 bg-white cursor-pointer hover:bg-gray-100 w-full"
                  onClick={() => toggleExpand(report._id)}
                >
                  <span
                    className="w-[6%] rounded"
                    style={{ backgroundColor: projectColor }}
                  ></span>
                  <p className="w-[64%] text-start text-[12px] ml-1 ">{report.ProjectName}</p>
                  <p className="w-[30%] text-end text-[12px] ">{totalHoursAssigned} hr</p>
                </div>

                {isExpanded && (
                  <div className="bg-gray-50 p-2 pl-3 max-h-[9rem] overflow-y-auto">
                    {report?.WorkEntries.map((entry, index) => (
                      <div
                        key={index}
                        className="border-b py-1  flex justify-between text-[11px]"
                      >
                        <p className="pl-2">{entry.task}</p>
                        <p className="">{entry.hoursassigned}hr</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>

      </div>
    );
  };

  return (
    <>
      <div className="h-full">
        <div className="perticularproject bg-white rounded-md  h-full">
          <div className="relative h-[10%] flex align-middle items-center p-2">
            <h3 className="font-semibold">Projects & Time Entries</h3>

            <div className="absolute right-1 top-0 show-potential-download lg:justify-end cp:hidden">
              <div className=" flex items-center rounded-md justify-between pt-2 pr-2 ">
                {probabilityTab === "table" && (
                  <span title="Graph">
                    <SignalCellularAltIcon
                      className="cursor-pointer"
                      onClick={() => setProbabilityTab("graph")}
                      // fontSize="6rem"
                      sx={{ fontSize: "1.2rem" }}   // ← change size here
                    />
                  </span>
                )}
                {probabilityTab === "graph" && (
                  <span title="Table">
                    <TableChartIcon
                      className="cursor-pointer"
                      onClick={() => setProbabilityTab("table")}
                      // fontSize="6rem"
                      sx={{ fontSize: "1.2rem" }}   // ← change size here
                    />
                  </span>
                )}
              </div>
            </div>
          </div>
          <hr />
          <hr />
          {probabilityTab === "graph" && (
            <div className="w-full flex flex-col cp:flex-row gap-1 h-[90%] overflow-auto">
              <div className="w-full cp:w-1/2 h-[300px]">
                <div className="h-full flex justify-center items-center">
                  <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                      <Pie
                        data={datadonut}
                        cx="50%"
                        cy="50%"
                        innerRadius={50}
                        outerRadius={100}
                        fill="#8884d8"
                        paddingAngle={2}
                        dataKey="value"
                      >
                        {datadonut.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            // fill={COLORSdonut[index % COLORSdonut.length]}
                            fill={getColorForIndex(index)}

                          />
                        ))}
                      </Pie>
                      <Tooltip
                        content={({ active, payload }) => {
                          if (active && payload && payload.length) {
                            return (
                              <div className="bg-white border px-2 py-1 text-sm">
                                {payload[0].name}
                              </div>
                            );
                          }
                          return null;
                        }}
                      />
                    </PieChart>
                  </ResponsiveContainer>
                </div>
              </div>

              <div className="hidden cp:block cp:w-1/2 max-h-full overflow-y-auto border p-1">
                <TimeEntriesTg />
              </div>
            </div>
          )}

          {probabilityTab === "table" && (
            <div className=" p-2">
              <TimeEntriesTg classlist="w-full h-full" />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TimeEntriesGraph;
